import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import DialogContent from "@material-ui/core/DialogContent";
import { Box, Grid, Switch, Typography } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { userActions } from "../../../_redux/actions";
import { useDispatch, useSelector } from "react-redux";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { utilFunctions } from "../../../_helpers";
import { alertActions } from "../../../_redux/actions";
import FormControlWrapper from "../../_shared/FormControlWrapper";

const UserAdd = (props) => {
    const INITIAL_STATE = {
        id: { value: null },
        username: { value: '', validator: 'email', isRequired: true, error: null, disable: false },
        license: { value: '', validator: 'text', isRequired: true, error: null, disable: false },
        firstName: { value: '', validator: 'text', isRequired: true, error: null, disable: false },
        lastName: { value: '', validator: 'text', isRequired: true, error: null, disable: false },
        roles: { value: [], validator: 'array', isRequired: true, error: null, disable: false },
        isActive: { value: true }
    }
    const dispatch = useDispatch();
    const roleList = useSelector((state: any) => state.users.roleList);
    const createUser = useSelector((state: any) => state.users.createUser);
    const [userData, setUserData] = useState(INITIAL_STATE);

    React.useEffect(() => {
        // dispatch getUserRoleList action & fetch user roles list
        dispatch(userActions.getUserRoleList(null,
            () => { },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }))
        if (!!props.user) {
            dispatch(userActions.getUserDetail(props.user.email,
                (res) => {
                    let selectedRoles: number[] = [];
                    if (!!res.userRoles && res.userRoles.length > 0) {
                        res.userRoles.forEach(row => {
                            if (row.isAssigned) selectedRoles.push(row.id)
                        })
                    }

                    setUserData({
                        ...userData,
                        id: { ...userData.id, value: +props.user.id },
                        username: { ...userData.username, value: res.userEmail, disable: true },
                        license: { ...userData.license, value: res.tulitaLicenseNo },
                        firstName: { ...userData.firstName, value: res.firstName },
                        lastName: { ...userData.lastName, value: res.lastName },
                        isActive: { ...userData.isActive, value: res.isActive },
                        roles: { ...userData.roles, value: selectedRoles }
                    })
                },
                (error) => {
                    dispatch(alertActions.triggerAlert(true, error, 'error'))
                }))
        }
        if (props.reset > 0) {
            handleClear();
        }
    }, [props.user, props.reset])

    const handleChange = (property, value) => {
        setUserData({
            ...userData,
            [property]: {
                ...userData[property],
                value: value,
                error: null
            }
        })
    }

    const handleClear = () => {
        setUserData(INITIAL_STATE);
    }

    const validateForm = async () => {
        const [validatedData, isValid]: any = await utilFunctions.validateFormData(userData)
        setUserData({ ...validatedData });
        if (isValid) {
            props.addUser(validatedData);
        }
    }

    return (
        <React.Fragment>
            <DialogContent>
                <Typography className="uppercase fontSizePrimary">Please fill the detail below to add a new user to the platform.</Typography>
                <Typography className="uppercase fontSizePrimary mtM">
                    <Box color="error.main" fontSize={14}>{createUser.isError ? createUser.error.message : null}</Box>
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="User Email" variant="block"  isRequired={userData.username.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => handleChange('username', event.target.value)}
                                value={userData.username.value}
                                error={!!userData.username.error}
                                disabled={userData.username.disable}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Tulita License" variant="block" isRequired={userData.license.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => handleChange('license', event.target.value)}
                                value={userData.license.value}
                                error={!!userData.license.error}
                                disabled={userData.license.disable}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="First Name" variant="block" isRequired={userData.firstName.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => handleChange('firstName', event.target.value)}
                                value={userData.firstName.value}
                                error={!!userData.firstName.error}
                                disabled={userData.firstName.disable}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Last Name" variant="block" isRequired={userData.lastName.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => handleChange('lastName', event.target.value)}
                                value={userData.lastName.value}
                                error={!!userData.lastName.error}
                                disabled={userData.lastName.disable}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Role" variant="block" isRequired={userData.roles.isRequired}>
                            <Select
                                multiple
                                onChange={(event) => handleChange('roles', event.target.value as string[])}
                                value={userData.roles.value}
                                error={!!userData.roles.error}
                                margin="dense"
                                variant="outlined"
                                disabled={userData.roles.disable}
                            >
                                {roleList.data.map((element) => (
                                    <MenuItem key={element.id} value={element.id}>{element.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} >
                        <FormControlWrapper label="Is Active" variant="block" >
                            <Switch
                                checked={userData.isActive.value}
                                onChange={(event) => handleChange('isActive', event.target.checked)}
                                name="checkedA"
                                color="primary"
                            />
                        </FormControlWrapper>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleClear}>
                    Clear
                </Button>
                <Button variant="contained" color="secondary" onClick={validateForm}>
                    Save
                </Button>
            </DialogActions>
        </React.Fragment>
    )

}

UserAdd.propTypes = {
    user: PropTypes.any,
    reset: PropTypes.number,
    addUser: PropTypes.func,
    onClose: PropTypes.func,
}
UserAdd.defaultProps = {
    reset: 0
}

export default UserAdd;
